import React from "react";
import "../style/footer2.css";

export default function Footer2() {
  return (
    <div className="footer2">
      <div>
        <p>© VAMA Skylight LLP 2025. All rights reserved.</p>
        <p>
          Developed By :  <span className="dev">Byteproc Solutions Pvt. Ltd.</span>{" "}
        </p>
      </div>
    </div>
  );
}
